<template>
  <div>
    <div dir="ltr" class="between light2 rounded-xl px-4 py-2 z-10 mb-4">
      <div
        @click="delivery = false"
        :class="` ${!delivery ? 'opacity-0' : ''}`"
      >
        &lt;
      </div>
      <div class="font-semibold m-auto uppercase">
        {{ delivery ? $t("fixed.cart.delivery") : $t("fixed.product.group") }}
      </div>
      <div @click="delivery = true" :class="` ${delivery ? 'opacity-0' : ''}`">
        >
      </div>
    </div>
    <div
      v-if="!products.length"
      class="text-sm text-center my-4 text-slate-400 dark:text-slate-500"
    >
      {{ $t("fixed.cart.empty") }}
    </div>
    <div v-else-if="!delivery" class="grid-1">
      <div
        v-for="product in products"
        :key="product.id"
        class="w-full h-24 between relative"
        dir="rtl"
      >
        <div class="w-9/12 p-2">
          <div
            @click="$router.push(`/product/${product.id}`)"
            dir="auto"
            class="truncate"
          >
            {{ product.name }}
          </div>
          <div dir="auto" class="my-2">
            <span class="text-sm text-slate-500 dark:text-slate-400">{{
              $t("fixed.size")
            }}</span>
            <span class="text-sm mx-2 uppercase">{{
              product.selectedSize ? product.selectedSize : $t("fixed.standard")
            }}</span>
          </div>
          <div :dir="$doc('html').dir == 'rtl' ? 'ltr' : 'rtl'" class="between">
            <div dir="rtl" class="start">
              <h6 class="text-xs mx-2">DZD</h6>
              <h1 class="font-medium">
                {{ product.quantity * product.price }}
              </h1>
            </div>
            <div class="w-5/12 between">
              <a
                @click="quantity(product.id, product.quantity + 1)"
                class="m-auto"
                >+</a
              >
              <div class="w-3/12 text-center m-auto">
                {{ product.quantity }}
              </div>
              <a
                @click="
                  product.quantity > 1
                    ? quantity(product.id, product.quantity - 1)
                    : false
                "
                class="m-auto"
                >-</a
              >
            </div>
          </div>
        </div>
        <div
          class="w-3/12 min-h-full bg rounded-xl mr-1"
          :style="`background-image: url(${product.images[0]})`"
        >
          <div
            @click="remove(product.id)"
            class="text-xs absolute top-0 left-0 transform -translate-x-2 -translate-y-2 bg-slate-400 dark:bg-slate-500 text-white pt-1 px-1.5 rounded-xl"
          >
            X
          </div>
        </div>
      </div>
      <div class="h-24"></div>
    </div>
    <div v-else-if="delivery" class="grid-1">
      <div class="text-center m-auto uppercase">
        {{ $t("fixed.cart.infoO") }}
      </div>
      <div>
        {{ $t("fixed.cart.productsN") }}
        <span class="mx-2">
          {{ products.length }}
        </span>
      </div>
      <div>
        {{ $t("fixed.cart.deliveryP") }}
        <span class="mx-2 uppercase"> {{ $t("fixed.cart.free") }} </span>
      </div>
      <div class="flex">
        {{ $t("fixed.cart.totalP") }}
        <span dir="auto" class="start mx-2">
          <h1 class="tracking-wider font-medium m-auto">
            {{
              products.reduce((a, b) => {
                return a + b.price * b.quantity;
              }, 0)
            }}
          </h1>
          <h6 class="text-xs mx-2">DZD</h6>
        </span>
      </div>
      <div>
        {{ $t("fixed.cart.paymentM") }}
        <span class="mx-2 uppercase"> {{ $t("fixed.cart.receipt") }} </span>
      </div>
      <div class="text-center mt-4 uppercase">{{ $t("fixed.cart.infoD") }}</div>
      <input
        type="text"
        class="py-3 px-4 light2 rounded-xl outline-none text-center"
        :placeholder="$t('fixed.input.name')"
        v-model="deliveryInfo[0]"
      />
      <input
        type="tel"
        class="py-3 px-4 light2 rounded-xl outline-none text-center"
        :placeholder="$t('fixed.input.phone')"
        v-model="deliveryInfo[1]"
      />
      <textarea
        cols="30"
        rows="10"
        class="py-3 px-4 h-24 light2 rounded-xl outline-none text-center"
        :placeholder="$t('fixed.input.place')"
        v-model="deliveryInfo[2]"
      ></textarea>
      <h6
        class="text-slate-400 dark:text-slate-500 w-7/12 text-center text-xs m-auto"
      >
        {{ $t("fixed.input.req") }}
      </h6>
    </div>
    <div dir="ltr" class="bottom between w-full light">
      <div class="w-6/12 light2 p-2 rounded-xl m-auto">
        <div class="start">
          <h1 class="tracking-wider font-medium m-auto">
            {{
              products.reduce((a, b) => {
                return a + b.price * b.quantity;
              }, 0)
            }}
          </h1>
          <h6 class="text-xs mx-2">DZD</h6>
        </div>
      </div>
      <button-app
        @action="delivery ? show('confirm') : (delivery = true)"
        :svg="delivery ? 'done' : 'delivery'"
        :text="$t(`fixed.cart.${delivery ? 'order' : 'delivery'}`)"
        :theme="`btnB2 w-5/12 ${
          delivery && (deliveryInfo.includes('') || !products.length)
            ? 'opacity-50'
            : ''
        }`"
      />
    </div>
    <div v-if="alert" class="alert-back">
      <div class="alert-front">
        <div class="text-title uppercase">{{ $t(alert.title) }}</div>
        <div class="p-8 g-center">
          <svg-app :type="alert.svg" theme="w-12" />
        </div>
        <a :href="alert.link" class="text-dis">{{ $t(alert.dis) }}</a>
        <div class="text-sub-1">
          {{ $t(alert.subDis, { code: this.code }) }}
        </div>
        <div v-if="alert.action != false" dir="ltr" class="between pt-4">
          <button-app
            v-if="!alert.process"
            @action="no()"
            :text="$t('fixed.no')"
            svg="x"
          />
          <button-app
            @action="yes()"
            :text="$t('fixed.yes')"
            :svg="alert.process ? 'process' : 'done'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buttonApp from "@/components/buttonApp.vue";
import svgApp from "@/components/svgApp.vue";
import { db } from "@/assets/db";

export default {
  components: { buttonApp, svgApp },
  data() {
    const code = () => {
      let code = "";
      for (let i = 0; i < 6; i++) {
        code += Math.floor(Math.random() * 10);
      }

      return code;
    };

    return {
      products: [],
      delivery: false,
      orderInfo: {},
      deliveryInfo: ["", "", ""],
      process: false,
      code: code(),
      alert: null,
    };
  },
  async created() {
    this.products = await db.products.where({ cart: "true" }).toArray();
    if (localStorage.deliveryInfo) {
      this.deliveryInfo = JSON.parse(localStorage.getItem("deliveryInfo"));
    }
  },
  methods: {
    async quantity(id, data) {
      await db.products.update(id, { quantity: data });
      this.products = this.products.map((product) =>
        product.id == id ? { ...product, quantity: data } : product
      );
    },
    async remove(id) {
      await db.products.update(id, { cart: false });
      this.products = this.products.filter((product) => {
        return product.id != id;
      });
    },
    show(type) {
      switch (type) {
        case "confirm":
          if (!this.deliveryInfo.includes("") && this.products.length) {
            this.alert = {
              type: "confirm",
              title: "fixed.confirm",
              svg: "bag",
              dis: "fixed.alert.confirm",
            };
          }
          break;
        case "geolocation":
          if (navigator.geolocation) {
            navigator.permissions
              .query({ name: "geolocation" })
              .then((result) => {
                if (result.state == "prompt") {
                  this.alert = {
                    type: "geolocation",
                    title: "fixed.alert.location",
                    svg: "location",
                    dis: "fixed.alert.geolocation",
                    process: false,
                  };
                } else {
                  this.show("notification");
                }
              });
          } else {
            this.show("notification");
          }
          break;
        case "notification":
          if (
            "Notification" in window &&
            Notification.permission == "default"
          ) {
            this.alert = {
              type: "notification",
              title: "fixed.alert.notification",
              svg: "notification",
              dis: "fixed.alert.askNotice",
              process: false,
            };
          } else {
            this.show("creating");
          }
          break;
        case "creating":
          this.alert = {
            type: "creating",
            title: "fixed.cart.order",
            svg: "bag",
            dis: "fixed.alert.creating",
            action: false,
          };
          db.orders
            .add({
              id:
                Date.now().toString(36) + Math.random().toString(36).substr(2),
              deliveryInfo: this.deliveryInfo,
              products: this.products,
              time: Date.now(),
              code: this.code,
            })
            .then(() => {
              setTimeout(() => {
                this.alert = {
                  type: "done",
                  title: "fixed.alert.done",
                  svg: "done",
                  dis: "fixed.alert.created",
                  subDis: "fixed.alert.disCreated",
                  action: false,
                };
              }, 2000);
            });
          break;
        default:
          break;
      }
    },
    yes() {
      switch (this.alert.type) {
        case "confirm":
          localStorage.setItem(
            "deliveryInfo",
            JSON.stringify(this.deliveryInfo)
          );
          this.show("geolocation");
          break;
        case "geolocation":
          this.alert.process = true;
          navigator.geolocation.getCurrentPosition(
            () => {
              this.show("notification");
            },
            () => {
              this.show("notification");
            }
          );
          break;
        case "notification":
          this.alert.process = true;
          Notification.requestPermission(
            () => {
              this.show("creating");
            },
            () => {
              this.show("creating");
            }
          );
          break;
        default:
          break;
      }
    },
    no() {
      switch (this.alert.type) {
        case "confirm":
          this.alert = false;
          break;
        case "geolocation":
          this.show("notification");
          break;
        case "notification":
          this.show("creating");
          break;
        default:
          break;
      }
    },
  },
};
</script>
